import * as types from './mutation_types'
import Vue from 'vue'
import { defaultBlocStyle, defaultElementStyle, defaultImageStyle } from '../../../config/constanteUse'
import { setRowId, setAddedToFiche, setAddedToFicheTemplate, getColonneHeaderKeysAddedToFiche, getDropHeaderKeysAddedToFiche, addAndRemoveDuplicate, getConteneurHeaderKeysAddedToFiche } from './utils'
export default {
  [types.SET_SELECTED_FICHES] (state, value) {
    state.selectedFiches = value;
  },
  [types.SET_FICHE_TABLEAU_DATA] (state, value) {
    state.ficheTableauData = value
  },
  [types.SET_ESPACE_FICHE] (state, payload) {
    Object.keys(payload).forEach(key => {
      const index = state.ficheTableauData.findIndex(e => e.id + '' === key)
      if (index >= -1) {
        Vue.set(state.ficheTableauData[index], 'rows', [...payload[key].rows])
      }
    })
  },
  [types.SET_CURRENT_FICHE] (state, value) {
    state.currentFiche = value
  },
  [types.SET_CURRENT_LIGNE] (state, value) {
    state.currentLigne = value
  },
  [types.SET_LAST_FICHE] (state, value) {
    state.lastFiche = value
  },
  [types.SET_CURRENT_FICHE_DATA] (state, value) {
    state.currentFicheData = value
  },
  [types.ADD_CONTENEUR] (state, payload) {
    state.currentFicheData.data.elements.push(payload)
  },
  [types.ADD_CONTENEUR_AFTER] (state, payload) {
    state.currentFicheData.data.elements.splice(payload.index, 0, payload.data)
  },
  [types.DELETE_CONTENEUR] (state, index) {
    const { onglet, ligne } = state.currentFicheData
    const headerKey = getConteneurHeaderKeysAddedToFiche(state.currentFicheData.data.elements[index])
    state.deletedHeaders = [...state.deletedHeaders, ...headerKey]
    if (!state.isProjectTemplate) {
      setAddedToFiche(state.ficheTableauData.find(el => el.id + '' === onglet + ''), { onglet, ligne, headerKey, value: false })
    } else {
      setAddedToFicheTemplate(state.currentFicheData, { headerKey, value: false })
    }
    state.currentFicheData.data.elements.splice(index, 1)
  },
  [types.ADD_COLONNE] (state, payload) {
    const { index, colSize } = payload
    state.currentFicheData.data.elements[index].childElements.push({ type: 'colonne', class: colSize, style: null, childElements: [] })
  },
  [types.DELETE_COLONNE] (state, payload) {
    const { onglet, ligne } = state.currentFicheData
    const { conindex, colindex } = payload
    const headerKey = getColonneHeaderKeysAddedToFiche(state.currentFicheData.data.elements[conindex].childElements[colindex])
    state.deletedHeaders = [...state.deletedHeaders, ...headerKey]
    if (!state.isProjectTemplate) {
      setAddedToFiche(state.ficheTableauData.find(el => el.id + '' === onglet + ''), { onglet, ligne, headerKey, value: false })
    } else {
      setAddedToFicheTemplate(state.currentFicheData, { headerKey, value: false })
    }
    state.currentFicheData.data.elements[conindex].childElements.splice(colindex, 1)
  },
  [types.RESIZE_COLONNE] (state, payload) {
    const { conindex, colindex, size } = payload
    state.currentFicheData.data.elements[conindex].childElements[colindex].class = size
  },
  [types.ADD_ELEMENT] (state, payload) {
    const { conindex, colindex, type } = payload
    if (type === 'text') {
      state.currentFicheData.data.elements[conindex].childElements[colindex].childElements.push({ type, value: 'Texte par défaut', style: { ...defaultElementStyle } })
    } else if (type === 'drop') {
      state.currentFicheData.data.elements[conindex].childElements[colindex].childElements.push({ type, style: { ...defaultBlocStyle }, childElements: [] })
    } else if (type === 'logo') {
      state.currentFicheData.data.elements[conindex].childElements[colindex].childElements.push({ type, style: { ...defaultImageStyle }, size: { w: 150, h: 150 }, src: null })
    } else if (type === 'image') {
      state.currentFicheData.data.elements[conindex].childElements[colindex].childElements.push({ type, style: { ...defaultImageStyle }, src: null })
    }
  },
  [types.TEXT_ELEMENT_EDIT] (state, payload) {
    const { conindex, colindex, elindex, value } = payload
    state.currentFicheData.data.elements[conindex].childElements[colindex].childElements[elindex].value = value
  },
  [types.DELETE_ELEMENT] (state, payload) {
    const { onglet, ligne } = state.currentFicheData
    const { conindex, colindex, elindex } = payload
    if (state.currentFicheData.data.elements[conindex].childElements[colindex].childElements[elindex].type === 'drop') {
      const headerKey = getDropHeaderKeysAddedToFiche(state.currentFicheData.data.elements[conindex].childElements[colindex].childElements[elindex])
      state.deletedHeaders = [...state.deletedHeaders, ...headerKey]
      if (!state.isProjectTemplate) {
        setAddedToFiche(state.ficheTableauData.find(el => el.id + '' === onglet + ''), { onglet, ligne, headerKey, value: false })
      } else {
        setAddedToFicheTemplate(state.currentFicheData, { headerKey, value: false })
      }
    }

    state.currentFicheData.data.elements[conindex].childElements[colindex].childElements.splice(elindex, 1)
  },
  [types.SELECTED_FICHE] (state, value) {
    state.selectedFiche = value
  },
  [types.IS_LOADING_FICHE_DATA] (state, value) {
    state.isLoadingFicheData = value
  },
  [types.IS_LOADING_FICHE_ESPACES] (state, value) {
    state.isLoadingFicheEspaces = value
  },
  [types.DROP_ELEMENT_EDIT] (state, payload) {
    const { conindex, colindex, elindex, value } = payload
    state.currentFicheData.data.elements[conindex].childElements[colindex].childElements[elindex].childElements = value
  },
  [types.SET_ADDED_TO_FICHE] (state, payload) {
    const { onglet, ligne } = state.currentFicheData
    if (state.isProjectTemplate) {
      setAddedToFicheTemplate(state.currentFicheData, { headerKey: payload.headerKey, value: payload.value })
      return
    }
    setAddedToFiche(state.ficheTableauData.find(el => el.id + '' === onglet + ''), { onglet, ligne, headerKey: payload.headerKey, value: payload.value, erase: payload.erase })
  },
  [types.UPDATE_COLONNE_ORDER] (state, payload) {
    const { conindex, value } = payload
    state.currentFicheData.data.elements[conindex].childElements = value
  },
  [types.UPDATE_ELEMENT_ORDER] (state, payload) {
    const { conindex, colindex, value } = payload
    state.currentFicheData.data.elements[conindex].childElements[colindex].childElements = value
  },
  [types.UPDATE_ELEMENT] (state, payload) {
    const { conindex, colindex, elindex, data } = payload

    Object.keys(data).forEach(key => {
      state.currentFicheData.data.elements[conindex].childElements[colindex].childElements[elindex][key] = data[key]
    })
  },
  [types.UPDATE_IMAGE_SRC] (state, payload) {
    const { conindex, colindex, elindex, src, dimension } = payload
    state.currentFicheData.data.elements[conindex].childElements[colindex].childElements[elindex]['src'] = src
    state.currentFicheData.data.elements[conindex].childElements[colindex].childElements[elindex]['dimension'] = dimension
  },
  [types.UPDATE_CONTAINER] (state, payload) {
    const { conindex, data } = payload
    Object.keys(data).forEach(key => {
      state.currentFicheData.data.elements[conindex][key] = data[key]
    })
  },
  [types.UPDATE_COLONNE] (state, payload) {
    const { conindex, colindex, data } = payload

    Object.keys(data).forEach(key => {
      state.currentFicheData.data.elements[conindex].childElements[colindex][key] = data[key]
    })
  },
  [types.IS_LOADING_TEMPLATES_FICHE] (state, value) {
    state.isLoadingTemplatesFiche = value
  },
  [types.TEMPLATES_FICHE] (state, payload) {
    const { ongletId, data } = payload
    addAndRemoveDuplicate(state.templatesFiche, ongletId, data)
  },
  [types.IS_PROJECT_TEMPLATE] (state, value) {
    state.isProjectTemplate = value
  },
  [types.TEMPLATE_ID] (state, value) {
    localStorage.setItem('template_id', value)
    state.templateId = value
  },
  [types.IS_LOADING_FICHES] (state, value) {
    state.isLoadingFiches = value
  },
  [types.ADD_DROPPED_HEADER] (state, value) {
    state.droppedHeaders = [...state.droppedHeaders, value]
  },
  [types.OVERWRITE_DROPPED_HEADER] (state, value) {
    state.droppedHeaders = value
  },
  [types.ADD_DELETED_HEADER] (state, value) {
    state.deletedHeaders = [...state.deletedHeaders, ...value]
  },
  [types.OVERWRITE_DELETED_HEADER] (state, value) {
    state.deletedHeaders = value
  },
  [types.UPDATE_FICHE_TITLE] (state, payload) {
    state.currentFicheData.data.titre = payload
  },
  [types.TABLEAU_TEMPLATE_ID] (state, payload) {
    state.tableauTemplateId = payload
  },
  [types.SET_ROW_ID] (state, payload) {
    setRowId(state.ficheTableauData.find(el => el.id + '' === payload.onglet + ''), payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ficheEspace/mutations.js